import SelectableTable from 'components/Tables/SelectableTable';
import React from 'react';
import theme from 'source/theme';
import tableIcons from 'utils/icons/materialTableIcons';

export default (rowData, onSelection, scenarios, lcsById) => {
  const columns = [
    { title: 'Código', field: 'code' },
    { title: 'LCS', field: 'lcs_name' },
    { title: 'Designação', field: 'designation' }
  ];

  const productScenarios = scenarios.filter(s => s.product_id && s.product_id == rowData.id);

  let augmentedScenarios = [];
  productScenarios.forEach( scenario => {
    augmentedScenarios.push({
      ... scenario,
      lcs_name: lcsById[scenario.lcs_id].description
    });
  });

  return ({
    icon: tableIcons.Descriptors,
    tooltip: 'Visualizar cenários',
    render: () =>
      <div style={{ padding: 10, backgroundColor: theme.palette.background.light }}>
        <SelectableTable
          title='Cenários Produto'
          currentRow={{}}
          columns={columns}
          rows={augmentedScenarios}
          onSelection={onSelection}
        />
      </div>
  });
};
